import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'requestTypeFilter',
  pure: false
})
export class RequestTypeFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValues: Array<number | string> | null): any {
    if (!requestList || !filterValues?.length) {
      return requestList;
    }
    const selected = new Set(filterValues.map(value => Number(value)));
    return requestList.filter(request => selected.has(Number(request.FKIDRequestType)));
  }

}
